import { NgModule, InjectionToken, ModuleWithProviders, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule, NzMenuBaseService } from 'ng-zorro-antd';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { CookieService } from 'ngx-cookie-service';

import { LoginModalComponent } from './auth/login-modal.component';
import { ResetPasswordComponent } from './auth/reset-password.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    NgxWebstorageModule,
    RouterModule,
  ],
  declarations: [LoginModalComponent, ResetPasswordComponent],
  entryComponents: [LoginModalComponent, ResetPasswordComponent],
  providers: [ CookieService, NzMenuBaseService ],
  exports: []
})
export class FxServicesModule {}

